import { fetchAiApps } from './aiApps';
import { fetchAiMarketOverview } from './aiMarketOverview';
import { fetchTimeSpentPenetration } from './timeSpentPenetration';
import {
  fetchUsageTrends,
  fetchUsageTransitions,
  fetchSegmentConcentration,
} from './marketBehavior';
import { fetchSectorsStats } from './sectorsStats';
import { fetchAiAppTrends, fetchSegmentTransitions } from './aiAppTrends';
import { fetchAiAppImpact, fetchFinanceAppPreselect, fetchFinanceApps } from './aiAppImpact';

import { aiDashboardAssets } from '../configs/constants';

export {
  fetchTimeSpentPenetration,
  fetchUsageTransitions,
  fetchAiAppTrends,
  fetchSegmentTransitions,
  fetchAiAppImpact,
  fetchFinanceApps,
  fetchSectorsStats,
};

export const fetchAiDashboardData =
  ({ campaignEnded = false } = {}) =>
  (dispatch, getState) => {
    const { aiDashboard } = getState();

    const isAssetLoaded = (assetName) => aiDashboard[assetName].settings.loaded;

    if (!isAssetLoaded(aiDashboardAssets.apps)) {
      dispatch(fetchAiApps({ campaignEnded }));
    }

    // Skip all chart data when campaign has ended — no real data should be fetched or exposed
    if (campaignEnded) return;

    if (!isAssetLoaded(aiDashboardAssets.marketOverview)) {
      dispatch(fetchAiMarketOverview());
    }

    if (!isAssetLoaded(aiDashboardAssets.timeSpentPenetration)) {
      dispatch(fetchTimeSpentPenetration());
    }

    if (!isAssetLoaded(aiDashboardAssets.usageTrends)) {
      dispatch(fetchUsageTrends());
    }

    if (!isAssetLoaded(aiDashboardAssets.usageTransitions)) {
      dispatch(fetchUsageTransitions());
    }

    if (!isAssetLoaded(aiDashboardAssets.segmentConcentration)) {
      dispatch(fetchSegmentConcentration());
    }

    if (!isAssetLoaded(aiDashboardAssets.sectorsStats)) {
      dispatch(fetchSectorsStats());
    }

    if (!isAssetLoaded(aiDashboardAssets.financeApps)) {
      dispatch(fetchFinanceAppPreselect());
    }
  };
